const resources = {
    callUs: 'Call Us',
    phone: '1-877-SEPHORA (1-877-737-4672)',
    phoneLocation: '(US or Canada)',
    hearingImpaired: 'Deaf and Hard-of-Hearing/TTY',
    hearingImpairedPhone: '1-888-866-9845',
    hearingImpairedLink: 'see Accessibility',
    representative: 'Representatives are available:',
    monFri: 'MON-FRI',
    monFriTime: '5am - 9pm PT',
    satSun: 'SAT-SUN',
    satSunTime: '6am - 9pm PT'
};

export default function getResource(label) {
    return resources[label];
}
